import { createSelector } from 'reselect';
import { getIsApmERPJobFlow } from './getIsApmERPJobFlow';
import { getProgramEvents } from './getProgramEvents';
import { getOpenLaborTicketRefs } from './getOpenLaborTicketRefs';

const CLOSED_STATUSES = ['COMPLETED', 'CANCELLED'];

/**
 * Work order operation refs of the jobs on this machine's APM board (the
 * grouped program-event cards). Uses the board's own visibility rules: a
 * confirmed card whose labor ticket is no longer open is off the board unless
 * it's paused or waiting for production. Closed jobs can't be targets, so
 * they're left out too.
 */
export const getApmActiveJobWooRefs = createSelector(
  [getIsApmERPJobFlow, getProgramEvents, getOpenLaborTicketRefs],
  (isApmERPJobFlow, programEvents, openLaborTicketRefs) => {
    if (!isApmERPJobFlow) {
      return [];
    }
    const openLtRefs = new Set(openLaborTicketRefs);
    const refs = programEvents
      .filter((event) => {
        if (event.workOrderOperationRef == null) return false;
        const status = (event.status || '').toUpperCase();
        if (event.closedDate != null || CLOSED_STATUSES.includes(status)) {
          return false;
        }
        if (event.paused || event.waitingForProduction) return true;
        if (event.confirmedAt && event.laborTicketRef) {
          return openLtRefs.has(event.laborTicketRef);
        }
        return true;
      })
      .map((event) => {
        return Number(event.workOrderOperationRef);
      });
    return [...new Set(refs)];
  }
);
